import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Tour } from 'src/classes/tour';
import { AuxService } from '../aux.service';

@Component({
  selector: 'app-tour-sequence',
  templateUrl: './tour-sequence.component.html',
  styleUrls: ['./tour-sequence.component.css'],
  standalone: false,
})
export class TourSequenceComponent {
  constructor(
    private router: Router,
    private aux: AuxService,
  ) {}

  @Input() tour: Tour;
  @Input() idArticle: number;

  redirectArticle(article) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([
        '/tour/' +
          this.tour.id +
          '-' +
          this.aux.slugify(this.tour.name) +
          '/article/' +
          article,
      ]);
    });
  }
}
